module.exports = __webpack_public_path__ + "img/banner.c8801009.svg";